/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  quickToolService,
  signaturesPdfService,
  Address,
  INSTANCE
) => {
  /**
   * Prepare privacy disclosure statement for Australian's asset finance.
   *
   * @param {Boolean} pageBreak
   * @returns {Array}
   */
  const preparePrivacyDisclosureStatementForAssetFinanceAU = ({ pageBreak }) => {
    const content = [];
    if (!pageBreak) {
      content.push({
        text: '',
        margin: [0, 10, 0, 0]
      });
    }
    content.push(
      helperPdfService.createHeader({
        title: 'PRIVACY DISCLOSURE STATEMENT AND CONSENT',
        pageBreak: pageBreak || ''
      })
    );
    content.push({
      alignment: 'justify',
      columns: [
        [
          { text: 'Overview', bold: true },
          {
            text: `${$rootScope.CurrentOrganization?.organization?.name}, ABN ${
              $rootScope.CurrentOrganization?.organization?.abn
            }, of ${Address.getAddress(
              $rootScope.CurrentOrganization?.organization?.address
            )} ('we', 'us', 'our') collects information about you for the purposes you agree to in this Privacy Disclosure Statement and Consent. When you sign below, you agree we can, consistently with Australia's privacy and credit reporting laws, collect, use and exchange consumer and/or commercial credit and personal information ('information') about you for those purposes.`
          },
          {
            text: 'Privacy Disclosure Statement and Consent',
            bold: true,
            style: 'marginTop'
          },
          { text: 'We are collecting information about you, as applicable:' },
          {
            ul: [
              { text: 'To source for you, or a company of which you are a  director:' },
              {
                ul: [
                  {
                    text: 'Consumer credit for personal, household, domestic or residential investment purposes;'
                  },
                  { text: 'Commercial credit for business purposes; or' },
                  {
                    text: 'Other services stated in this Privacy Disclosure Statement and Consent (Consent); or'
                  }
                ]
              },
              { text: 'To support a guarantor application you will provide' }
            ]
          },
          {
            text: "As your broker, we require the information we collect from you to assess your credit, or guarantor, application or the credit application of a company of which you are a director, source a suitable credit provider and any required insurances and to manage the application process, where required. If you do not provide the information sought we may be unable to process your application, or the company's application, or we may be limited in the other services we can offer you or the company.",
            style: 'marginTop'
          },
          {
            text: 'Your information - Collection and Disclosure',
            bold: true,
            style: 'marginTop'
          },
          {
            text: 'When we collect information from you in the credit or guarantor application process, we use that information in a number of ways to assess your application and, where appropriate, to source a suitable credit provider or lessor  and / or insurance provider.  We may, as appropriate:'
          },
          {
            ul: [
              {
                text: 'Disclose and exchange your personal and identification information to a consumer credit reporting bureau (‘Consumer CRB’) and/or a commercial credit reporting bureau (‘Commercial CRB’), if you wish us to obtain a report on your behalf;'
              },
              {
                text: 'Use any information a CRB provides in its report to assist us to preliminarily assess your credit or guarantor application;'
              },
              {
                text: 'Disclose your information to an insurer or insurers to source any insurances you wish to obtain; and'
              },
              {
                text: 'Disclose your information to our advisers, aggregators, licensees and other financial intermediaries, a credit provider or credit providers to apply for finance on your behalf.'
              }
            ],
            style: 'marginTop'
          },
          {
            text: "The information we obtain from you is used, subject to compliance with Australia's privacy and credit reporting laws, only for the purposes listed in this Consent and is not disclosed to any other person except with your permission or as permitted, or required, by law.",
            style: 'marginTop'
          }
        ],
        [
          {
            text: 'Credit Providers',
            bold: true
          },
          {
            text: 'As part of providing our services to you, we may undertake tasks for a credit provider which are reasonably necessary to manage the application process. When doing so, we are acting as agent for the credit provider, with the same privacy law requirements applying to both of us.'
          },
          {
            text: 'We may submit your application to one or more credit providers. Those credit providers and their website addresses are set out in the Schedule 1 at the end of this document.',
            style: 'marginTop'
          },
          {
            text: 'A credit provider, to whom we submit an application, may disclose information about you to, and collect information about you from, one or more Consumer CRB or Commercial CRB.',
            style: 'marginTop'
          },
          {
            text: "The website of each credit provider contains details of each Consumer CRB and Commercial CRB with which it deals and other details about information held about you, including whether that information may be held or disclosed overseas and, if so, in which countries. The websites also describe your key rights. These details may be described on the credit providers' websites as 'notifiable matters', 'privacy policy', 'credit reporting policy' or 'privacy disclosure statement and consent', or similar. Further information or clarification can be obtained from the credit providers direct via the contact details on their website.",
            style: 'marginTop'
          },
          {
            text: 'For each Consumer CRB a credit provider uses the website details will include the following specific information:',
            style: 'marginTop'
          },
          {
            ul: [
              {
                text: 'That the CRB may include information the credit provider discloses about you to other credit providers to assess your credit worthiness'
              },
              {
                text: 'That, if you become overdue in making consumer credit payments or you commit a serious credit infringement, the credit provider may disclose that information to the Service'
              },
              {
                text: "How you can obtain the credit provider's and/or the Service's policies about managing your information"
              },
              {
                text: 'Your right to access and/or correct information held about you and to complain about conduct that may breach the privacy and credit reporting laws'
              },
              {
                text: 'Your right to request a CRB not to undertake pre-screening for purposes of direct marketing by a credit provider'
              },
              {
                text: 'Your right to request a CRB not to release information  about you if you believe you are a victim of fraud'
              }
            ]
          },
          {
            text: 'This detail will also be included by the credit provider who approves your application in the privacy disclosure statement and consent document it will provide to you.',
            style: 'marginTop'
          }
        ]
      ],
      columnGap: 20,
      style: ['value', 'marginTop']
    });
    content.push({
      pageBreak: 'before',
      alignment: 'justify',
      columns: [
        [
          {
            text: 'Each credit provider website includes information on how to contact it and how to obtain a copy of its privacy documents in a form that suits you (e.g. hardcopy or email).'
          },
          {
            text: 'Your rights',
            bold: true,
            style: 'marginTop'
          },
          {
            text: 'You have the right to ask:'
          },
          {
            ul: [
              { text: 'Us to provide you with all the information we hold about you' },
              { text: 'Us to correct the information we hold if it is incorrect' },
              {
                text: 'Us for copies of our privacy policy and this document, in a form that suits you (e.g. hardcopy or email)'
              },
              {
                text: 'A Consumer CRB not to use your information for direct marketing assessment purposes, including  pre-screening'
              },
              {
                text: 'A credit reporting service to provide you with a copy of any information it holds about you'
              }
            ]
          },
          {
            text: `You can gain access to the information we hold about you by contacting our Privacy Officer at the address above or by telephone on ${$rootScope.CurrentOrganization?.organization?.licenses?.in3} or email at ${$rootScope.CurrentOrganization?.organization?.licenses?.id3}. In some cases an administration fee may be charged to cover the cost of providing the information. Our Privacy Policy also deals with our complaints process and is available on our website at www.astutefinancial.com.au/privacy-policy or we will provide you with a copy if you ask us.`,
            style: 'marginTop'
          },
          {
            text: 'Schedule 2 at the end of this document sets out the contact details for each Credit Reporting Service.',
            style: 'marginTop'
          },
          {
            text: 'Disclosure and Consent',
            bold: true,
            style: 'marginTop'
          },
          {
            text: 'By signing below, you agree we may:'
          },
          {
            ul: [
              { text: 'Use your information:' },
              {
                ul: [
                  {
                    text: 'To assess your consumer or commercial credit and/or guarantee application and/or to assess a credit application by a company of which you are a director'
                  },
                  { text: 'To source any finances you required' },
                  {
                    text: 'To source any insurances you require'
                  },
                  { text: 'As the law authorises or requires;' }
                ]
              },
              {
                text: 'Disclose to, and obtain from, any prospective credit provider or insurer, information about you that is reasonably necessary to obtain the finance and insurances you require;'
              },
              {
                text: 'Obtain from, and disclose to, any third party, information about you, the applicant(s) or guarantor(s) that is reasonably necessary to assist you obtain the finance and insurances required;'
              },
              {
                text: 'Provide your information, including your credit report(s), to one or more of the credit providers specified in Schedule 1 at the end of this document so they can assess your application, or the application of a company of which you are a director, or your suitability as a guarantor'
              },
              {
                text: 'Provide information about you to a guarantor, or prospective guarantor;'
              },
              {
                text: 'Provide you, or the company of which you are a director, with offers or information of other goods or services we, or any of our associated entities, may be able to provide to  you or the company, unless you tell us not to;'
              },
              {
                text: 'Disclose your information to the extent permitted by law to other organisations that provide us with services, such as contractors, agents, printers, mail houses, lawyers, document custodians, securitisers and computer systems consultants or providers, so they can perform those services for us. Some of which may be located overseas.'
              }
            ]
          }
        ],
        [
          {
            ul: [
              {
                text: 'Disclose your information to any other organisation that may wish to acquire, or has acquired, an interest in our business or any rights under your contract with us, or the contract with us of a company of which you are a director.'
              },
              {
                text: 'Upon settlement of any facility organised by us, receive a commission from the Lender.'
              }
            ]
          },
          {
            text: 'You also agree and consent to, as appropriate:',
            style: 'marginTop'
          },
          {
            ul: [
              {
                text: 'A Consumer CRB disclosing information to one or more credit providers specified in Schedule 1 at the end of this document for the purpose of assessing your application for consumer or commercial credit or your guarantor application, and/or assessing a credit application by a company of which you are a director'
              },
              {
                text: 'When you are a prospective guarantor, a credit provider using that information to assess your suitability as a guarantor'
              },
              {
                text: 'A credit provider disclosing your information (including information obtained by it from a Consumer CRB) to a guarantor, or a prospective guarantor'
              },
              {
                text: 'A credit provider disclosing to another credit provider, to your agent, such as us as your broker, or to a servicer, for a particular purpose, information it holds about you'
              }
            ]
          },
          {
            text: 'Extended Effectiveness for Commercial Credit',
            bold: true,
            style: 'marginTop'
          },
          {
            text: 'Your agreement and consent to the disclosures and consents in this document will be effective for a period of 12 months, but only in relation to commercial credit. Your agreement to this ceases when you either withdraw it by contacting us using our details above or 12 months after you sign below, whichever first occurs. This will allow us to continue to provide our services to you without the need to ask you to sign a new privacy statement and consent each time you require commercial credit within a 12 month period. The extended effectiveness does not apply in relation to consumer credit.'
          },
          {
            text: "Where the applicant, or guarantor, is a company of which you are a director, you consent to the disclosure and use of your information, in addition to the company's information, in each of the ways specified in this document.",
            style: 'marginTop'
          }
        ]
      ],
      columnGap: 20,
      style: ['value']
    });
    return content;
  };

  /**
       * Prepare schedule one for Australian's asset finance.
       *
       * @param {Boolean} pageBreak

       * @returns {Array}
       */
  const prepareSchedulesForAssetFinanceAU = () => {
    const content = [];
    content.push(
      helperPdfService.createHeader({
        title: 'SCHEDULE 1 - CREDIT PROVIDERS',
        pageBreak: 'before'
      })
    );
    content.push({
      table: {
        headerRows: 1,
        widths: ['18%', '36%', '18%', '28%'],
        body: [
          [
            {
              text: 'Name of credit provider',
              bold: true
            },
            {
              text: 'Website',
              bold: true
            },
            {
              text: 'Name of credit provider',
              bold: true
            },
            {
              text: 'Website',
              bold: true
            }
          ],
          [
            {
              text: 'Affordable car loans'
            },
            {
              text: 'www.affordablecarloans.com.au'
            },
            {
              text: 'Liberty'
            },
            {
              text: 'www.liberty.com.au'
            }
          ],
          [
            {
              text: 'AFS'
            },
            {
              text: 'www.afs.com.au'
            },
            {
              text: 'MAIA Financial'
            },
            {
              text: 'www.maiafinancial.com.au'
            }
          ],
          [
            {
              text: 'AMMF'
            },
            {
              text: 'www.ammf.com.au'
            },
            {
              text: 'Medfin Australia'
            },
            {
              text: 'www.medfin.com.au'
            }
          ],
          [
            {
              text: 'Angle Finance'
            },
            {
              text: 'www.anglefinance.com.au'
            },
            {
              text: 'Metro Finance'
            },
            {
              text: 'www.metrofin.com.au'
            }
          ],
          [
            {
              text: 'ANZ Bank'
            },
            {
              text: 'www.anz.com'
            },
            {
              text: 'Metro CF Pty Ltd'
            },
            {
              text: 'www.metrofin.com.au'
            }
          ],
          [
            {
              text: 'Australian Military Bank'
            },
            {
              text: 'www.australianmilitarybank.com.au'
            },
            {
              text: 'Money3'
            },
            {
              text: 'www.money3.com.au'
            }
          ],
          [
            {
              text: 'Bankwest'
            },
            {
              text: 'www.bankwest.com.au'
            },
            {
              text: 'Moneyplace'
            },
            {
              text: 'www.moneyplace.com.au'
            }
          ],
          [
            {
              text: 'BOQ Equipment Finance'
            },
            {
              text: 'www.boq.com.au'
            },
            {
              text: 'Moneytech Services P/L'
            },
            {
              text: 'www.moneytech.com.au'
            }
          ],
          [
            {
              text: 'BOQ Specialist Bank Limited'
            },
            {
              text: 'www.bogspecialist.com.au'
            },
            {
              text: 'Morris Finance'
            },
            {
              text: 'www.morrisfinance.com.au'
            }
          ],
          [
            {
              text: 'BOQF Cashflow Finance'
            },
            {
              text: 'www.boqfcf.com.au'
            },
            {
              text: 'National Australia Bank'
            },
            {
              text: 'www.nab.com.au'
            }
          ],
          [
            {
              text: 'Capital Finance'
            },
            {
              text: 'www.capitalfinance.com.au'
            },
            {
              text: 'NOW Finance'
            },
            {
              text: 'www.nowfinance.com.au'
            }
          ],
          [
            {
              text: 'Cashflow Finance'
            },
            {
              text: 'www.cashflowfinance.com.au'
            },
            {
              text: 'Pepper Money'
            },
            {
              text: 'www.pepper.com.au'
            }
          ],
          [
            {
              text: 'Clearmatch'
            },
            {
              text: 'www.clearmatch.com'
            },
            {
              text: 'Plenti'
            },
            {
              text: 'www.plenti.com.au'
            }
          ],
          [
            {
              text: 'Commonwealth Bank'
            },
            {
              text: 'www.commbank.com.au'
            },
            {
              text: 'Qld Country Bank'
            },
            {
              text: 'www.queenslandcountry.bank'
            }
          ],
          [
            {
              text: 'Commercial Equity Group'
            },
            {
              text: 'www.commercialequitygroup.com.au'
            },
            {
              text: 'Resimac Asset Finance'
            },
            {
              text: 'www.resimac.com.au'
            }
          ],
          [
            {
              text: 'Dynamoney'
            },
            {
              text: 'www.dynamoney.com'
            },
            {
              text: 'ScotPac'
            },
            {
              text: 'www.scotpac.com.au'
            }
          ],
          [
            {
              text: 'Earlypay'
            },
            {
              text: 'www.earlypay.com.au'
            },
            {
              text: 'Selfco'
            },
            {
              text: 'www.selfco.com.au'
            }
          ],
          [
            {
              text: 'Firstmac'
            },
            {
              text: 'www.firstmac.com.au'
            },
            {
              text: 'Shift Financial'
            },
            {
              text: 'www.shift.com.au'
            }
          ],
          [
            {
              text: 'Fleetpartners'
            },
            {
              text: 'www.fleetpartners.com.au'
            },
            {
              text: 'Silverchef'
            },
            {
              text: 'www.silverchef.com.au'
            }
          ],
          [
            {
              text: 'FlexFleet'
            },
            {
              text: 'www.flexfleet.com.au'
            },
            {
              text: 'Vestone Capital'
            },
            {
              text: 'www.vestonecapital.com'
            }
          ],
          [
            {
              text: 'flexicommercial Pty Ltd'
            },
            {
              text: 'www.flexicommercial.com'
            },
            {
              text: 'Westpac'
            },
            {
              text: 'www.westpac.com.au'
            }
          ],
          [
            {
              text: 'Group & General Finance'
            },
            {
              text: 'www.groupandgeneral.com '
            },
            {
              text: 'WISR'
            },
            {
              text: 'www.wisr.com.au'
            }
          ],
          [
            {
              text: 'Judo Bank'
            },
            {
              text: 'www.judo.bank'
            },
            {
              text: 'Yellowgate group'
            },
            {
              text: 'www.ygg.com.au'
            }
          ],
          [
            {
              text: 'Latitude'
            },
            {
              text: 'www.latitudefinancial.com.au'
            },
            '',
            ''
          ]
        ]
      },
      style: ['value', 'marginTop'],
      layout: 'defaultLayout'
    });
    content.push({
      text: '',
      margin: [0, 50, 0, 0]
    });
    content.push(
      helperPdfService.createHeader({
        title: 'SCHEDULE 2 - CONSUMER/COMMERCIAL CREDIT REPORTING SERVICES'
      })
    );
    content.push({
      table: {
        headerRows: 1,
        widths: ['20%', '30%', '50%'],
        body: [
          [
            {
              text: 'Name',
              bold: true
            },
            {
              text: 'Website/Email address',
              bold: true
            },
            {
              text: 'Telephone',
              bold: true
            }
          ],
          [
            {
              text: 'Experian'
            },
            {
              text: 'www.experian.com.au'
            },
            {
              text: '(03) 8622 1600'
            }
          ],
          [
            {
              text: 'IIlion'
            },
            {
              text: 'www.illion.com.au'
            },
            {
              text: '13 23 33'
            }
          ],
          [
            {
              text: 'equifax'
            },
            {
              text: 'www.equifax.com.au/contact-us'
            },
            {
              text: '13 83 32'
            }
          ]
        ]
      },
      style: ['value', 'marginTop'],
      layout: 'defaultLayout'
    });
    return content;
  };

  /**
   * Prepare privacy disclosure statement.
   *
   * @param {Array} contacts
   * @param {Object} ticketOwner
   * @param {Object} workflow
   * @param {Boolean} pageBreak
   *
   * @returns {Array}
   */
  const preparePrivacyDisclosureStatement = ({
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    workflow,
    pageBreak
  }) => {
    const content = [];
    if (workflow?.isAssetFinance() && helperService.getOrganizationCountry().cca2 === 'AU') {
      content.push(preparePrivacyDisclosureStatementForAssetFinanceAU({ pageBreak }));
      content.push(
        signaturesPdfService.prepareSignaturesDetails({
          contacts,
          contactLabels,
          ticket,
          ticketOwner,
          pageBreak: 'before',
          showIntroducer: false
        })
      );
      content.push(prepareSchedulesForAssetFinanceAU());
    }
    return content;
  };

  /**
   * Create application form PDF.
   *
   * @param {Array} contacts
   * @param {Array} contactLabels
   * @param {Array} lenders
   * @param {Object} ticket
   * @param {Object} ticketOwner
   * @param {Object} loan
   * @param {Object} workflow
   * @param {Boolean} isView
   *
   * @returns {Array}
   */
  const createPrivacyDisclosureStatement = ({
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    workflow,
    isView
  }) => {
    const deferred = $q.defer();
    const orgLogo = $rootScope.CurrentOrganization?.organization?.logo
      ? $rootScope.CurrentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          $rootScope.CurrentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    let docDefinition = {};
    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
      docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 20, 40, 20],
        content: [
          {
            table: {
              widths: ['*'],
              headerRows: 1,
              body: [
                [
                  {
                    width: 180,
                    height: 30,
                    image: res.data,
                    margin: [5, 3, 0, 3],
                    style: 'tableHeader'
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          preparePrivacyDisclosureStatement({
            contacts,
            contactLabels,
            ticket,
            ticketOwner,
            workflow
          })
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 0]
          },
          subHeader: {
            fontSize: 11,
            margin: [0, 0, 0, 0]
          },
          subSubHeader: {
            fontSize: 10,
            margin: [0, 2, 0, 0]
          },
          prepared: {
            fontSize: 9,
            alignment: 'left',
            margin: [0, 2, 0, 0]
          },
          marginTop: {
            margin: [0, 7, 0, 0]
          },
          marginBottom: {
            margin: [0, 0, 7, 0]
          },
          tableHeader: {
            fillColor: '#eee'
          },
          label: { fontSize: 8, color: '#777' },
          value: { fontSize: 10 },
          valueXS: { fontSize: 8 },
          valueXL: { fontSize: 12 },
          lists: { fontSize: 10 },
          noColor: { color: '#fff' }
        }
      };
      pdfMake.tableLayouts = {
        defaultLayout: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 1 : 0.5;
          },
          vLineWidth() {
            return 0.5;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
          },
          paddingLeft() {
            return 4;
          },
          paddingRight() {
            return 4;
          },
          paddingTop() {
            return 2;
          },
          paddingBottom() {
            return 2;
          }
        },
        header: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 2;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#000' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        subHeader: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 0.5;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#999' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 2;
          },
          paddingBottom() {
            return 2;
          }
        },
        noBorders: {
          hLineWidth() {
            return 0;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor() {
            return 0;
          },
          paddingLeft() {
            return 5;
          },
          paddingRight() {
            return 5;
          },
          paddingTop() {
            return 3;
          },
          paddingBottom() {
            return 3;
          }
        }
      };
      const fileName = `${moment.utc().year()}${moment.utc().month() + 1}${moment
        .utc()
        .date()} Privacy disclosure statement and consent.pdf`;
      if (!_.isEmpty(docDefinition)) {
        if (isView) {
          helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
            deferred.resolve();
          });
        } else {
          helperPdfService
            .viewOrSavePdf({
              ticket,
              docDefinition,
              fileName,
              isView: false
            })
            .then(() => {
              deferred.resolve();
            });
        }
      }
    });
    return deferred.promise;
  };

  return {
    createPrivacyDisclosureStatement,
    preparePrivacyDisclosureStatement
  };
};
